import { render, staticRenderFns } from "./download-resume.vue?vue&type=template&id=45b9c147"
import script from "./download-resume.vue?vue&type=script&lang=js"
export * from "./download-resume.vue?vue&type=script&lang=js"
import style0 from "./download-resume.vue?vue&type=style&index=0&id=45b9c147&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports